import React from 'react'
import { Container, Line } from './index.styled';

function Hamburguer({width = '40px', height = '21px', color='#FFF'}) {
  return (
    <Container width={width} height={height} color={color}>
      <Line /><Line /><Line />
    </Container>
  )
}

export default Hamburguer
